import * as React from "react";
import styled from "styled-components";
import { OverlayTrigger, Icon } from "components/common";
const StyledSpan = styled.span`
  margin-right: 5px;
`;
const ErrorPopover = ({ errorText, title = "Error", placement = "bottom" }) => /* @__PURE__ */ React.createElement(OverlayTrigger, { trigger: ["hover", "focus"], placement, overlay: errorText, title, width: 400 }, /* @__PURE__ */ React.createElement(StyledSpan, null, /* @__PURE__ */ React.createElement(Icon, { name: "warning", className: "text-danger", "data-testid": title.toLowerCase().replaceAll(" ", "-") })));
export default ErrorPopover;
